import { SHOPIFY_SCOPES } from "../../TldrSettings/TldrConnectedApps/NewConnectedAppModal/constants";
import { OAUTH_CALLBACK_URL, SHOPIFY_AUTH_URL, SHOPIFY_CLIENT_ID } from "../../_actions/endpoints";
import queryString from "query-string";
import Format from "string-format";
import { v4 } from "uuid";
import {openUrl} from "@simplified-workspace/shared/util";

export function toParams(query) {
  const q = query.replace(/^(\?|#)/, "");

  return q.split("&").reduce((values, param) => {
    const [key, value] = param.split("=");

    return { ...values, [key]: decodeURIComponent(value) };
  }, {});
}

export function toQuery(params, delimiter = "&") {
  const keys = Object.keys(params);

  return keys.reduce((str, key, index) => {
    let query = `${str}${key}=${params[key]}`;

    if (index < keys.length - 1) {
      query += delimiter;
    }

    return query;
  }, "");
}


export function startShopifyOAuth(shop){
  const nonce = v4();
  localStorage.setItem("nonce", nonce);

  const requestPayload = {
    client_id: SHOPIFY_CLIENT_ID,
    redirect_uri: OAUTH_CALLBACK_URL,
    response_type: "code",
    state: nonce,
    scope: SHOPIFY_SCOPES.join(" ")
  };
  const search = queryString.stringify(requestPayload);
  let url = Format(SHOPIFY_AUTH_URL, shop)+'?'+search;
  openUrl(url, "_self");
}
